var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.identityProvider)?_c('div',[_c('identity-provider-form',{attrs:{"errors":_vm.errors,"model":_vm.identity_provider,"title":`Edit ${_vm.identityProvider.name} Identity Provider`,"action":"updateIdentityProvider"},on:{"updateIdentityProvider":_vm.updateIdentityProvider}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }